import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { environment, oldEnvironment } from 'src/environments/environment';
import { PermissionsService } from './services/permissions/permissions.service';
declare var $: any;

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
})
export class AppComponent {
	title = 'LMS Leads';
	env = environment;
	oldEnv = oldEnvironment;
	database = '';

	constructor(public http: HttpClient, private router: Router){}

	ngOnInit(): void {
		this.getDatabaseName();

		// Solo ejecutar getUserPermissions si no estamos en signin o signup
		const currentUrl = this.router.url;

	}

	getDatabaseName(){
		this.http.get(`${environment.api}config/get_database`).subscribe(
			(data: any) => {
				this.database = data.body.database_name;
			},
			(error: any) => {
				console.error('Error fetching database name:', error);
			}
		);
	}

}
